import { ErrorPage } from "../ui/ErrorPage";
import { routes } from "../routing/routes";

export function NotFound() {
  return (
    <ErrorPage
      title="Page not found"
      buttonHref={routes.main}
      buttonText="Go to account home"
    />
  );
}
